import { createSlice } from "@reduxjs/toolkit";
import { getAuthToken, getUser, setAuthData, logout as clearStorage } from "../../services/authService";

// Initial state - load from localStorage if available
const initialState = {
  isAuthenticated: !!getAuthToken(),
  user: getUser(),
  token: getAuthToken(),
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // Set loading state
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    // Set error state
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    // Clear error state
    clearError: (state) => {
      state.error = null;
    },
    // Login success - set user and token
    loginSuccess: (state, action) => {
      const { token, user } = action.payload;
      state.isAuthenticated = true;
      state.user = user;
      state.token = token;
      state.isLoading = false;
      state.error = null;
      
      // Persist to localStorage
      setAuthData(token, user);
    },
    // Logout - clear all auth data
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.isLoading = false;
      state.error = null;
      
      // Clear localStorage
      clearStorage();
    },
    // Update user data
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      // Update localStorage
      if (state.token) {
        setAuthData(state.token, state.user);
      }
    },
    // Initialize auth from localStorage (on app load)
    initializeAuth: (state) => {
      const token = getAuthToken();
      const user = getUser();
      if (token && user) {
        state.isAuthenticated = true;
        state.user = user;
        state.token = token;
      }
    },
  },
});

// Export actions
export const {
  setLoading,
  setError,
  clearError,
  loginSuccess,
  logout,
  updateUser,
  initializeAuth,
} = authSlice.actions;

// Export reducer
export default authSlice.reducer;

// Selectors
export const selectAuth = (state) => state.auth;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectAuthLoading = (state) => state.auth.isLoading;
export const selectAuthError = (state) => state.auth.error;



